import React, { useEffect, useState } from 'react';
import { useBrand } from '../context/TenantContext.jsx';

const DISMISS_KEY = 'afc_ios_a2hs_dismissed';

function isIos() {
  const ua = navigator.userAgent || '';
  const iOS = /iphone|ipad|ipod/i.test(ua);
  const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return iOS || iPadOS;
}

function isStandalone() {
  return (
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
  );
}

export default function IosInstallHint() {
  const brand = useBrand();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isIos() && !isStandalone() && localStorage.getItem(DISMISS_KEY) !== '1') {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="install-prompt d-flex align-items-center gap-3 px-3 py-2" role="banner" aria-label="Install app">
      <i className="fa-solid fa-arrow-up-from-bracket fs-4 text-white" aria-hidden="true" />
      <div className="flex-grow-1">
        <p className="mb-0 text-white fw-semibold small">Install {brand.shortName} on your device</p>
        <p className="mb-0 text-white opacity-75" style={{ fontSize: '0.75rem' }}>
          Tap the Share icon, then &ldquo;Add to Home Screen&rdquo;
        </p>
      </div>
      <button type="button" className="btn btn-link text-white p-0 border-0" aria-label="Dismiss" onClick={dismiss}>
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>
    </div>
  );
}
